import { OverlayWrapper } from "./MenuOverlay.styles";

const MenuOverlay = ({ isOpen = false, closeMenu }) => {
  return isOpen ? <OverlayWrapper onClick={closeMenu} /> : null;
};

export default MenuOverlay;
